module.exports = __webpack_public_path__ + "img/riccardocantoro.bbb1ca43.jpg";